import CreateTask from '../../pages/CreateTask';
import OrgAdminLayout from '../components/OrgAdminLayout';

// Reuses the shared CreateTask logic inside the org-admin shell so
// navigating here from Tasks Management doesn't swap the sidebar out
// from under the user.
function OrgAdminCreateTask() {
  return <CreateTask Layout={OrgAdminLayout} backPath="/org-admin/tasks" />;
}

export default OrgAdminCreateTask;
